import type { LucideIcon } from "lucide-react";

/**
 * 狀態頁的大圖示(取代 emoji):淡綠圓底 + 品牌綠細線條。
 * className 用來接原本的動畫 class / margin。
 * tone="onDark" 給深綠漸層底的頁面(收禮頁):淡綠圓底在深綠上對比太低,改半透明白底 + 白色線條。
 */
export default function StatusMark({
  icon: Icon,
  size = "md",
  tone = "light",
  className = "",
}: {
  icon: LucideIcon;
  size?: "md" | "lg";
  tone?: "light" | "onDark";
  className?: string;
}) {
  const box = size === "lg" ? "w-20 h-20" : "w-16 h-16";
  const px = size === "lg" ? 36 : 28;
  const color = tone === "onDark" ? "bg-white/10 text-white" : "bg-sage-light/50 text-primary";
  return (
    <div
      className={`${box} rounded-full ${color} flex items-center justify-center mx-auto ${className}`}
      aria-hidden="true"
    >
      <Icon size={px} strokeWidth={1.5} />
    </div>
  );
}
